var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('staggering-transition',{attrs:{"emitter":"toggleSlideTransition"}},[_c('h1',{key:_vm.title,staticClass:"title",on:{"click":_vm.click}},[_vm._v(" "+_vm._s(_vm.title)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }